import React from "react";
import { Backspace, BoxArrowInRight } from "react-bootstrap-icons";

const Letters = (props) => {
  const letterButtonPress = (e, letter) => {
    const keyDownLetter = new KeyboardEvent("keydown", {
      key: String(letter.letter),
      code: "Key" + String(letter.letter).toUpperCase(),
    });
    props.keyDown(keyDownLetter);
  };
  return (
    <div className="letter-wrapper">
      <div className="letter-buttons">
        {props.letters.map((letter) => {
          if (letter.letter === "Enter") {
            return (
              <React.Fragment key={letter.id}>
                <button
                  className={"wotdButton"}
                  style={{ width: "60px" }}
                  id={
                    letter.status === "FOUND"
                      ? "FOUND"
                      : letter.status === "CONTAINS"
                      ? "CONTAINS"
                      : letter.status === "BAD"
                      ? "BAD"
                      : ""
                  }
                  key={letter.id}
                  onClick={(e) => letterButtonPress(e, letter)}
                >
                  <BoxArrowInRight />
                </button>
              </React.Fragment>
            );
          } else if (letter.letter === "Backspace") {
            return (
              <React.Fragment key={letter.id}>
                <button
                  className={"wotdButton"}
                  style={{ width: "60px" }}
                  id={
                    letter.status === "FOUND"
                      ? "FOUND"
                      : letter.status === "CONTAINS"
                      ? "CONTAINS"
                      : letter.status === "BAD"
                      ? "BAD"
                      : ""
                  }
                  key={letter.id}
                  onClick={(e) => letterButtonPress(e, letter)}
                >
                  <Backspace />
                </button>
              </React.Fragment>
            );
          } else if (letter.letter !== undefined) {
            return (
              <React.Fragment key={letter.id}>
                <button
                  className={"wotdButton"}
                  id={
                    letter.status === "FOUND"
                      ? "FOUND"
                      : letter.status === "CONTAINS"
                      ? "CONTAINS"
                      : letter.status === "BAD"
                      ? "BAD"
                      : ""
                  }
                  key={letter.id}
                  onClick={(e) => letterButtonPress(e, letter)}
                >
                  {letter.letter}
                </button>
                {letter.letter === "p" ? <pre></pre> : null}
                {letter.letter === "l" ? <pre></pre> : null}
              </React.Fragment>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Letters;
